export const parseJSON = (inputString: string, fallback: any) => {
  try {
    return JSON.parse(inputString);
  } catch (e) {
    return fallback;
  }
};
